import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { useDeleteAccountLink } from "../../../renewals/api";

/**
 * Confirmation dialog for removing a sub-account link. The link is identified
 * by `link_id` (account_links.id from the renewals backend) — the partner
 * detail endpoint exposes this on each `sub_links[].link_id`.
 */
export function RemoveSubAccountDialog({
  link,
  open,
  onOpenChange,
}: {
  link: { link_id: string; name: string; sub_qb_id: number } | null;
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const del = useDeleteAccountLink();
  if (!link) return null;
  return (
    <Dialog open={open} onOpenChange={(v) => !del.isPending && onOpenChange(v)}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Remove sub-account?</DialogTitle>
          <DialogDescription>
            Remove <b>{link.name}</b> (QB-{link.sub_qb_id}) as a sub-account? Its billing
            will no longer roll into this partner's totals.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={del.isPending}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={async () => {
              try {
                await del.mutateAsync(link.link_id);
                onOpenChange(false);
              } catch {
                /* keep dialog open so the user can retry */
              }
            }}
            disabled={del.isPending}
          >
            {del.isPending ? "Removing…" : "Remove sub-account"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
